import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoButton from './InfoButton';

interface PlayerCountSelectorProps {
  playerCount: number;
  onChange: (count: number) => void;
  disabled?: boolean;
}

const PlayerCountSelector: React.FC<PlayerCountSelectorProps> = ({ 
  playerCount, 
  onChange, 
  disabled = false 
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6">
      <div className="flex items-center mb-2">
        <label className="text-lg font-semibold text-gray-800 dark:text-gray-100">
          {t('tableSetup.playerCount.label')}
        </label>
        <InfoButton
          title={t('tableSetup.playerCount.infoTitle')}
          content={t('tableSetup.playerCount.infoContent')}
        />
      </div>
      
      <div className="grid grid-cols-4 gap-2">
        {Array.from({ length: 8 }, (_, i) => i + 3).map(count => (
          <button
            key={count}
            type="button"
            onClick={() => onChange(count)}
            disabled={disabled}
            className={`
              py-3 px-4 rounded-lg font-medium text-lg transition-all duration-200
              ${playerCount === count 
                ? 'bg-blue-600 text-white shadow-lg scale-105' 
                : 'bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-gray-800 border-2 border-gray-200 dark:border-gray-800'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            {count}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlayerCountSelector;
